import { createStore, applyMiddleware, Store } from "redux";
import createSagaMiddleware from "redux-saga";

import rootReducer from "./rootReducer";
import rootSaga from "./rootSaga";

/**Types State dos modulos */
//import { AuthState } from "../modulos/auth/authTypes"
import { ClienteState } from "../modulos/cliente/cliente.model";
import { FuncionarioState } from "../modulos/funcionario/funcionario.model";
import { FornecedorState } from "../modulos/fornecedor/forn.model";
import { MeioPagState } from "../modulos/meioPag/meiopg.model";
import { ItemState } from "../modulos/item/item.model";
import { ConfigState } from "../modulos/config/config.model";
import { TipoMovState } from "../modulos/tipoMov/tipomov.model";
import { MovState } from "../modulos/movimentacoes/mov.model";
import { CanalDistribuicaoState } from "../modulos/canalDist/canalDist.model";
import { ContasState } from "../modulos/contas/contas.model";
import { EstoqueState } from "../modulos/estoque/estoque.model";
import { TabelaPrecoState } from "../modulos/settings/tabelaPreco/tabpreco.model";
import { ConvenioState } from "../modulos/settings/convenio/convenio.model";
import { GaleriaState } from "../modulos/galeria/galeria.model";

/**State geral para exibir os types na view */
export interface ApplicationState {
    clienteState:ClienteState,
    funcionarioState:FuncionarioState,
    fornecedorState:FornecedorState,
    meioPagState:MeioPagState,
    itemState:ItemState,
    configState:ConfigState,
    tipoMovState:TipoMovState,
    movState:MovState,
    canalDistribuicaoState:CanalDistribuicaoState,
    contasState:ContasState,
    estoqueState:EstoqueState,
    tabelaPrecoState:TabelaPrecoState,
    convenioState:ConvenioState,
    galeriaState:GaleriaState
}

const sagaMiddleware = createSagaMiddleware()

const store:Store <ApplicationState> = createStore(rootReducer, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(rootSaga);

export default store;
 